import React from 'react'
import '../../../styles/onboardingStep1.css';
import '../../../styles/onboardingStep2_1.css';
import { Button } from '@material-ui/core';
import { Redirect, withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Modal from "react-bulma-components/lib/components/modal";
// const imagesPath = {
//     unchecked: require('../../assets/unchecked.png'),
//     checked: require('../../assets/checked.png')
// }
import { createBrowserHistory as createHistory } from 'history'

const history = createHistory()
const imagesPath = {
    unchecked: require('../../../assets/unchecked_interest.png'),
    checked:require('../../../assets/checked_interest.png')

}

@inject('userStore', 'navigatorStore', 'authStore', 'userStore')
@withRouter
@observer
export default class onboardingStep_1 extends React.Component {
    constructor() {
        super();

        this.state = {
            onboardingInProcess: true,
            onboardingGoBack: false,
            userPreferences: "",
            preferences: {
                Oil: false,
                Acrylic: false,
                Watercolor: false,
                Graphite: false,
                Pencil: false,
                Charcoal: false
            }
        }
    }
    getData() {
        if (window.localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);
                    if (response.data[0].preferences != null) {
                        // console.log(response.data[0].preferences)
                        this.setState({
                            userPreferences: response.data[0].preferences,
                            preferences: {
                                ...this.state.preferences,
                                Oil: (response.data[0].preferences.includes("Oil")) ? true : false,
                                Watercolor: (response.data[0].preferences.includes("Watercolor")) ? true : false,
                                Acrylic: (response.data[0].preferences.includes("Acrylic")) ? true : false,
                                Charcoal: (response.data[0].preferences.includes("Charcoal")) ? true : false,
                                Pencil: (response.data[0].preferences.includes("Pencil")) ? true : false,
                                Graphite: (response.data[0].preferences.includes("Graphite")) ? true : false,
                                Mixed: (response.data[0].preferences.includes("Mixed")) ? true : false,
                                Pastel: (response.data[0].preferences.includes("Pastel")) ? true : false,
                                Ink: (response.data[0].preferences.includes("Ink")) ? true : false,

                            }
                        })
                    }
                })
        }
    }


    componentDidMount() {
        this.getData()

        if (window.location.href.includes("edit-profile") && this.props.navigatorStore.OB2Open) {
            this.backListener = history.listen(location => {
                // if (location.hash === "#/") {
                // Do your stuff
                // console.log("popping", location, window.location.href)
                this.props.navigatorStore.closeOB2Modal()
                this.props.history.replace('/edit-profile')

                // }
            });
        } else if ((window.location.href.includes("profile/details") || window.location.href.includes("product/details")) && this.props.navigatorStore.OB2Open) {
            // console.log("coming here")
            this.backListener = history.listen(location => {
                // if (location.hash === "#/") {
                window.localStorage.clear()
                window.location.reload()
            });
        }
        // this.backListener = history.listen((location, e) => {
        //     // if (location.hash === "#/onboardingone") {
        // Do your stuff
        // location.preventDefault();
        // // console.log("popping", location, e)

        // if (!window.location.href.includes("edit")) this.props.history.replace('/onboardingone')
        // }
        // });
    }
    close() {
        this.props.navigatorStore.closeOB2Modal()
    }
    handleClickingInterest(item) {
        switch (item) {
            case "Oil": {
                // console.log("checked oil")
                this.setState({ preferences: { ...this.state.preferences, Oil: !this.state.preferences.Oil } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Acrylic": {
                this.setState({ preferences: { ...this.state.preferences, Acrylic: !this.state.preferences.Acrylic } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Watercolor": {
                this.setState({ preferences: { ...this.state.preferences, Watercolor: !this.state.preferences.Watercolor } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Graphite": {
                this.setState({ preferences: { ...this.state.preferences, Graphite: !this.state.preferences.Graphite } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Pencil": {
                this.setState({ preferences: { ...this.state.preferences, Pencil: !this.state.preferences.Pencil } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Charcoal": {

                this.setState({ preferences: { ...this.state.preferences, Charcoal: !this.state.preferences.Charcoal } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Mixed": {

                this.setState({ preferences: { ...this.state.preferences, Mixed: !this.state.preferences.Mixed } }, () => { // console.log(this.state)
                })
                break;
            }
            case "Pastel": {

                this.setState({ preferences: { ...this.state.preferences, Pastel: !this.state.preferences.Pastel } }, () => { // console.log(this.state) 
                })
                break;
            }
            case "Ink": {

                this.setState({ preferences: { ...this.state.preferences, Ink: !this.state.preferences.Ink } }, () => { // console.log(this.state)
                })
                break;
            }
        }
    }

    nextStep(item) {
        // if(!this.state.preferences.Oil && !this.state.preferences.Watercolor && !this.state.preferences.Acrylic 
        //     && !this.state.preferences.Graphite && !this.state.preferences.Charcoal  && !this.state.preferences.Pencil){
        //       this.props.navigatorStore.openErrorModal("please choose your preferences");
        //     return;
        // }
        let body = ""
        if (item === "next") {

            if (this.state.preferences.Oil) {
                body = body.concat("Oil, ")
            }
            if (this.state.preferences.Watercolor) {
                body = body.concat("Watercolor, ")
            }
            if (this.state.preferences.Acrylic) {
                body = body.concat("Acrylic, ")
            }
            if (this.state.preferences.Graphite) {
                body = body.concat("Graphite, ")
            }
            if (this.state.preferences.Charcoal) {
                body = body.concat("Charcoal, ")
            }
            if (this.state.preferences.Pencil) {
                body = body.concat("Pencil, ")
            }
            if (this.state.preferences.Mixed) {
                body = body.concat("Mixed, ")
            }
            if (this.state.preferences.Pastel) {
                body = body.concat("Pastel, ")
            }
            if (this.state.preferences.Ink) {
                body = body.concat("Ink, ")
            }
            if (this.props.navigatorStore.editMode) {
                this.props.navigatorStore.closeOB2Modal()
                this.props.navigatorStore.closeOB3Modal()
                this.props.navigatorStore.displayEditedPreferences(body.substring(0, body.lastIndexOf(",")))
                this.props.history.replace('/edit-profile')
                return;
            } else {
                this.props.userStore.requestToEditUser(null, { preferences: body.substring(0, body.lastIndexOf(",")) })
                    .then((response) => {
                        // console.log(response)
                        this.props.navigatorStore.closeOB2Modal()
                        this.props.navigatorStore.openOB3Modal()
                    })
            }
        } else {

            this.props.navigatorStore.closeOB2Modal()
            this.props.navigatorStore.openOB3Modal()
        }
        // console.log(body);

        // this.setState({ onboardingInProcess: false })
    }


    render() {
        var Interests = [
            {
                paintingSet1:
                {
                    imageSrc: require('../../../assets/oil.jpg'),
                    interestName: "Oil",
                    checkedImg: this.state.Oil
                },
                paintingSet2:
                {
                    imageSrc: require('../../../assets/watercolor.jpg'),
                    interestName: "Watercolor",
                    checkedImg: this.state.Watercolor

                },

            },
            {
                paintingSet1:
                {
                    imageSrc: require('../../../assets/acrylic.jpg'),
                    interestName: "Acrylic",
                    checkedImg: this.state.Acrylic
                },
                paintingSet2:
                {
                    imageSrc: require('../../../assets/pencil.jpg'),
                    interestName: "Charcoal",
                    checkedImg: this.state.Charcoal
                },

            },
            {

                paintingSet1:
                {
                    imageSrc: require('../../../assets/mixed.jpg'),
                    interestName: "Pencil",
                    checkedImg: this.state.Pencil
                },
                paintingSet2:
                {
                    imageSrc: require('../../../assets/graphite.jpg'),
                    interestName: "Graphite",
                    checkedImg: this.state.Graphite
                },


            },
            {

                paintingSet1:
                {
                    imageSrc: require('../../../assets/mixed.jpg'),
                    interestName: "Mixed",
                    checkedImg: this.state.Mixed
                },
                paintingSet2:
                {
                    imageSrc: require('../../../assets/pastels.jpg'),
                    interestName: "Pastel",
                    checkedImg: this.state.Pastel
                },


            },
            {

                paintingSet1:
                {
                    imageSrc: require('../../../assets/ink.jpg'),
                    interestName: "Ink",
                    checkedImg: this.state.Ink
                },

                paintingSet2:
                {
                    hide: true,
                    imageSrc: require('../../../assets/oil_thumb.png'),
                    interestName: "Pastel",
                    checkedImg: this.state.Pastel
                },

            },
        ]
        if (this.state.navToOB1) {
            return (
                <Redirect push to='/onboardingone' />
            )
        }
        if (this.state.onboardingInProcess)
            return (
                <Modal show={this.props.navigatorStore.OB2Open}>
                    <Modal.Content >
                        <div className="heading-welcome">
                            LET'S TUNE YOUR FEED
                        <img
                                style={{ display: (window.location.href.includes("edit-profile")) ? "" : "none" }}
                                onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../../assets/cross_icon_for_close.png')}></img>
                            <hr className="line-category-name margin-auto"></hr>
                        </div>
                        <div className="container onboarding-container"
                            style={{ padding: "0px", width: "91%" }}>
                            <div className="content">
                                <div className="heading-text pb-25 mb-15">
                                    <div className="onboarding-question" style={{ paddingBottom: "2%" }}>
                                        What art styles do you like?
                            </div>
                                    <div className="onboarding-step-number"
                                        style={{ display: window.location.href.includes("edit") ? "none" : "" }}
                                    >
                                        Step 2 of 3
                                </div>
                                </div>
                                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>

                                    <InterestFields state={this.state} imagesPath={imagesPath} Interests={Interests} onClicking={this.handleClickingInterest.bind(this)} />
                                    <div className="row margin-25 mt-25">

                                        <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-left mb-30" style={{ marginBottom: "30px" }}>
                                            <Button className="masterpieces-secondary-buttons button-prev ml-0 step2-button-secondary"
                                                style={{ display: window.location.href.includes("edit") ? "none" : "" }}
                                                onClick={() => this.nextStep("skip")}>
                                                SKIP
                                    </Button>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-right mb-30" style={{ marginBottom: "30px" }}>
                                            <Button className="masterpieces-primary-buttons step2-button-primary"
                                                onClick={() => this.nextStep("next")}>{window.location.href.includes("edit") ? "SAVE" : "NEXT"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Content>
                </Modal>

            );
        if (!this.state.onboardingInProcess) {
            if (window.localStorage.hasOwnProperty("userData")) {

                this.props.authStore.resetOnboardingStatuses("onboardingTwoIncomplete")
                return (
                    <Redirect push to={window.location.href.includes("edit") ? '/edit-profile' : '/onboardingthree'} />
                )
            }
            else return (

                <Redirect push to='/' />
            )

        }


    }
}

const InterestFields = (props) => {
    let { Interests, imagesPath } = props
    // console.log(props.state)
    // console.log(props.state)
    return (

        Interests.map((el, elIndex) =>
            <div className="paintings-oil-acrylic" style={{ display: "flex", flexDirection: "row" }}>
                <div className="painting-oil" >

                    <div style={{ backgroundColor: "black" }}>
                        <img style={{ width : "281px",height : "107px"}}  src={el.paintingSet1.imageSrc} />
                    </div>
                    <p className="interest-name">{el.paintingSet1.interestName}</p>
                    <img alt="" alt="" className="checked-image" src={(props.state.preferences[el.paintingSet1.interestName]) ? imagesPath.checked : imagesPath.unchecked} onClick={() => props.onClicking(el.paintingSet1.interestName)} />
                    {/* el.paintingSet1.interestName */}
                </div>
                <div className="painting-acrylic" style={{ visibility: (el.paintingSet2.hide) ? "hidden" : "" }}>
                    <div style={{ backgroundColor: "black" }}>
                        <img style={{ width : "281px",height : "107px"}} alt="" src={el.paintingSet2.imageSrc} />
                    </div>

                    <p className="interest-name">{el.paintingSet2.interestName}</p>
                    <img  alt="" style={{ display: (!!el.paintingSet2.interestName) ? "" : "none" }} className="checked-image" src={!!el.paintingSet2.interestName && (props.state.preferences[el.paintingSet2.interestName]) ? imagesPath.checked : imagesPath.unchecked} onClick={() => props.onClicking(el.paintingSet2.interestName)} />
                </div>
            </div>
        )
    )
};


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/onboarding2-modal.js